import {useMemo} from 'react'

import {DEFAULT_CENTER, DEFAULT_DURATION, DEFAULT_ZOOM} from '../consts'
import {LngLat, LngLatBounds, MapLocationRequest} from '../types'

export type LocationsRequestData = {
  bounds?: LngLatBounds
  centerCoords?: LngLat
  duration?: number
  zoom?: number
}

export const useLocationsRequest = ({
  duration = DEFAULT_DURATION,
  zoom = DEFAULT_ZOOM,
  bounds,
  centerCoords,
}: LocationsRequestData): MapLocationRequest => {
  return useMemo<MapLocationRequest>(() => {
    if (bounds) {
      return {
        bounds,
        duration,
      }
    }
    if (centerCoords) {
      return {
        center: centerCoords,
        zoom,
        duration,
      }
    }
    return {
      center: DEFAULT_CENTER,
      zoom,
    }
  }, [bounds, centerCoords, zoom, duration])
}
